





















































































import { Component, Vue } from 'vue-property-decorator'
import RateField from '@/views/sorewards/settings/rate-field.vue'
import { getStandardRates, saveStandardRates } from '@/services/sorewards/console'
import { StandardRates } from '@/services/sorewards/types'

@Component({
  name: 'SorewardsStandardRates',
  components: {
    RateField
  }
})
export default class extends Vue {
  private loading = true
  private saving = false
  private editing = false
  private rates: StandardRates = {
    id: '',
    issuePhysical: 0,
    issueVirtual: 0,
    shipUnit: 0,
    shipGrouped: 0,
    loadFlat: 0,
    loadPct: 0
  }

  private draft: StandardRates = { ...this.rates }

  async created() {
    await this.fetchRates()
  }

  private async fetchRates() {
    this.loading = true
    try {
      this.rates = await getStandardRates()
      this.draft = { ...this.rates }
    } finally {
      this.loading = false
    }
  }

  private startEdit() {
    this.draft = { ...this.rates }
    this.editing = true
  }

  private cancel() {
    this.draft = { ...this.rates }
    this.editing = false
  }

  private async save() {
    this.saving = true
    try {
      this.rates = await saveStandardRates(this.draft)
      this.draft = { ...this.rates }
      this.editing = false
      this.$notify({
        title: String(this.$t('sorewardsConsole.saved')),
        message: '',
        type: 'success',
        duration: 2500
      })
    } finally {
      this.saving = false
    }
  }

  private money(value: number) {
    return this.$n(value, 'currency')
  }

  private percent(value: number) {
    return this.$n(value / 100, 'percent')
  }
}
